import React from 'react';
import { useAppSelector } from 'src/store';
import PublicBillingAndPlans from './PublicBillingAndPlans';
import PrivateBillingAndPlans from './PrivateBillingAndPlans';

const BillingAndPlans: React.FC = () => {
  const { isLoggedIn } = useAppSelector((state) => state.auth);

  // Render private version for authenticated users, public version for unauthenticated users
  return isLoggedIn ? <PrivateBillingAndPlans /> : <PublicBillingAndPlans />;
};

export default BillingAndPlans;
